import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=6f3f6a23&scoped=true"
import script from "./QuotationList.vue?vue&type=script&lang=ts"
export * from "./QuotationList.vue?vue&type=script&lang=ts"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=6f3f6a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f6a23",
  null
  
)

export default component.exports